import cn from 'classnames';
import React from 'react';

import { ReactComponent as WarningIcon } from '../../assets/images/icon-warning-round.svg';
import { OrgAddressFilterTypesEnum } from '../../constants/addressBook';
import { IOrgAddress } from '../../types/addressBook';
import { CompactOrgAddressView } from '../index';

import styles from './AddressList.module.scss';

interface IProps {
  addresses?: IOrgAddress[];
  isMaxHeightList?: boolean;
  error?: boolean;
}

export const AddressList: React.FC<IProps> = ({ addresses, isMaxHeightList, error = false }) => {
  return (
    <div className={cn(styles.container, { [styles.maxHeight]: isMaxHeightList, [styles.errorBorder]: error })}>
      {addresses?.length
        ? addresses?.map((address) => {
            const isNotActive = address.status === OrgAddressFilterTypesEnum.NotActive;
            return (
              <div key={address.uid} className={styles.row}>
                {isNotActive && <WarningIcon />}
                <CompactOrgAddressView row={address} isMultiline />
              </div>
            );
          })
        : null}
    </div>
  );
};

export default AddressList;
